
import ImportingIndexPage from '@/pages/importer/ImportingIndexPage.vue'
import OrganizationImportPage from '@/pages/importer/OrganizationImportPage.vue'

export default [
  {
    path: "/importers",
    name: 'ImportingIndexPage',
    component: ImportingIndexPage,
    children: [
      {
        path: "organizations/:organizationId",
        name: 'OrganizationImportPage',
        component: OrganizationImportPage,
        props: route => ({ organizationId: parseInt(route.params.organizationId) }),
        children: [
          // { path:'', name:'OrganizationDetailsPage', component: OrganizationDetailsPage, props: route => ({ organizationId: parseInt(route.params.organizationId) }) },
          // { path:'payment-setup', name:'OrganizationPaymentSetupPage', component: OrganizationPaymentSetupPage, props: route => ({ organizationId: parseInt(route.params.organizationId) }) },
          // { path:'payment-setup/finish-setup/:paymentServiceId', name:'OrganizationPaymentSetupPageFinishSetup', component: OrganizationPaymentSetupPage, props: route => ({ paymentServiceId: parseInt(route.params.paymentServiceId), organizationId: parseInt(route.params.organizationId) }) }
        ],
      },
    ]
  },

]
